import { Section } from "./Section";
import { Reveal } from "./Reveal";
import { FAQS } from "../../config/site";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

export const Faq = () => (
  <Section id="faq" overline="Questions" title="What buyers usually ask us">
    <Reveal>
      <Accordion type="single" collapsible className="mx-auto max-w-3xl" data-testid="faq-accordion">
        {FAQS.map((f, i) => (
          <AccordionItem key={f.q} value={`faq-${i}`} className="border-border">
            <AccordionTrigger
              className="text-left font-display text-lg sm:text-xl font-medium text-forest hover:text-gold-dark hover:no-underline"
              data-testid={`faq-trigger-${i}`}
            >
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm sm:text-base leading-relaxed text-[#4A4C4A]" data-testid={`faq-content-${i}`}>
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </Section>
);
